import React, { useEffect, useState } from "react";
import InfoComponent from "./InfoComponent/InfoComponent";
import "../../Components/ApproveAppointment/ApproveAppointment.css";
import { t } from "../../Utils/translate";
import utils from "../../Utils/index";
import GenerateCertificate from "./childComponent/GenerateCertificate/generateCertificate";
import MedicalNotes from "./childComponent/MedicleNotes/medicalNotes";
import moment from "moment";
import appointmentBW from "../../Assets/Images/appointmentBW.png";
import CustomModal from "../CustomModal/CustomModal";
import clinicService from "../../Services/clinicService";
import { FaLeaf } from "react-icons/fa";
import Widgets from "..";
import toast from "react-hot-toast";
import authService from "../../Services/authService";
import strings from "../../Utils/strings";
import { useNavigate, useLocation } from "react-router-dom";

const ApproveAppointmentDetail = ({ appointment, refreshAppointments, showTab, setShowTab }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [viewState, setviewState] = useState("Apointmentdetail");
  const [showModal, setShowModal] = useState();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedCertificates, setUploadedCertificates] = useState([]);
  const [uploadedInvoices, setUploadedInvoices] = useState([]); // State for uploaded invoices
  const [modalStatus, setModalStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [responseURL, setResponseURL] = useState();
  const [uploadTitle, setUploadTitle] = useState("");
  const [uploadDescription, setUploadDescription] = useState("");
  const res = responseURL?.replace(/ /g, "%20");
  const [uploadImgBody, setUploadImgBody] = useState({});
  const [uploadImgSuccess, setUploadImgSuccess] = useState("");
  const [zoomClass, setZoomClass] = useState("zoom-default");

  const updateZoomClass = () => {
    const viewportWidth = window.innerWidth;
    const screenWidth = window.screen.width;
    const zoomLevel = viewportWidth / screenWidth;

    if (zoomLevel >= 1.1) {
      setZoomClass("zoom-110"); // Apply this class for 110% zoom
    } else if (zoomLevel >= 1.0 && zoomLevel < 1.1) {
      setZoomClass("zoom-100"); // Apply this class for 100% zoom
    } else if (zoomLevel >= 0.9 && zoomLevel < 1.0) {
      setZoomClass("zoom-90"); // Apply this class for 90% zoom
    } else if (zoomLevel >= 0.8 && zoomLevel < 0.9) {
      setZoomClass("zoom-80");
    } else if (zoomLevel >= 0.6 && zoomLevel < 0.7) {
      setZoomClass("zoom-70");
    } else {
      setZoomClass("zoom-default"); // Fallback class for other zoom levels
    }
  };

  useEffect(() => {
    // console.log(showTab);
  }, [setShowTab]);

  useEffect(() => {
    window.addEventListener("resize", updateZoomClass);
    updateZoomClass(); // Initial check
    return () => window.removeEventListener("resize", updateZoomClass);
  }, []);

  useEffect(() => {
    if (uploadedFiles.length > 0) {
    }
  }, [uploadedFiles]);

  useEffect(() => {
    if (modalStatus === true) {
      setModalStatus(false);
    }
  }, [modalStatus]);

  const handleModalClose = () => {
    setShowModal(false);
    if (showModal === false || modalStatus === false) {
      setUploadedFiles([]);
      document.getElementById("fileUpload").value = "";
      // document.getElementById("fileUpload").disabled = false;
    }
  };

  const handleImageResponse = async (file) => {
    try {
      setIsLoading(true);
      let response = await clinicService.uploadHospitalMedia(file);
      setIsLoading(false);
      if (response.status === "success") {
        return response.data.urls[0];
      }
    } catch (error) {
      setIsLoading(false);
      console.error("File upload failed:", error);
      return null;
    }
  };

  const handleImageUpload = async (body) => {
    setShowModal(false);
    try {
      setIsLoading(true);
      let response;

      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.docUploadInvoices(appointment._id, body);
        console.log("response", response);
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.uploadDocs(appointment._id, body);
      }
      if (response.status === "success") {
        const body = {
          date: appointment.startTime,
          doctorId: appointment.doctor._id,
          appointmentId: appointment._id,
        };
        navigate(location.pathname, { state: body, replace: true });
        toast.success(t(uploadImgSuccess));
      }
    } catch (error) {
      setIsLoading(false);
      console.error("File upload failed:", error);
    } finally {
      setIsLoading(false);
    }
  };
  if (!appointment) {
    return (
      <div className="appointment-details-container p-3 bg-white d-flex justify-content-center ">
        <div className="d-flex justify-content-center align-items-center">
          <img className="no-appointments-image" src={appointmentBW} alt="No Appointment" />
        </div>
      </div>
    ); // Or handle loading state accordingly
  }

  const { doctor, patient } = appointment; 
  console.log(appointment);

  // if (!doctor || !patient) {
  //   return <div>{t('Invalid appointment data')}</div>; // Handle invalid data
  // }
  if (!doctor || !patient) {
    return (
      <div className="appointment-details-container p-3 bg-white d-flex justify-content-center">
        <div className="d-flex justify-content-center align-items-center">
          <img className="no-appointments-image" src={appointmentBW} alt="No Appointment" />
        </div>
      </div>
    ); // Handle invalid data with the same structure
  }
  const handleFileUpload = async (e) => {
    const files = e.target.files;
    if (files[0].type !== "application/pdf") {
      toast.error(t("plsUploadPdf"));
      return;
    }
    const response = await handleImageResponse(files[0]);
    if (response) {
      setUploadTitle("uploadEprescription");
      if (appointment.status === "STARTED") {
        setUploadDescription("sureUploadPrescriptionEndCall");
      } else {
        setUploadDescription("sureUploadPrescription");
      }
      setUploadImgSuccess("prescUploadSuccess");
      setShowModal(true);
      const body = {
        prescription: response?.replace(/ /g, "%20"),
      };
      setUploadImgBody(body);
    }
    e.target.value = "";
  };
  const handleCertificateUpload = async (e) => {
    const files = e.target.files;
    if (files[0].type !== "application/pdf") {
      toast.error(t("plsUploadPdf"));
      return;
    }
    const response = await handleImageResponse(files[0]);

    if (response) {
      setUploadTitle("uploadMedicalCerti");
      if (appointment.status === "STARTED") {
        setUploadDescription("sureuploadMedicalCertiEndCall");
      } else {
        setUploadDescription("sureuploadMedicalCerti");
      }
      setUploadImgSuccess("uploadMedicalCertiSuccess");
      setShowModal(true);
      const body = {
        medicalCertificate: response?.replace(/ /g, "%20"),
      };
      setUploadImgBody(body);
    }
    e.target.value = "";
  };
  const handleInvoiceUpload = async (e) => {
    console.log("calling model true");
    const files = e.target.files;
    if (files[0].type !== "application/pdf") {
      toast.error(t("plsUploadPdf"));
      return;
    }
    const response = await handleImageResponse(files[0]);
    if (response) {
      setUploadTitle("UploadInvoice");
      if (appointment.status === "STARTED") {
        setUploadDescription("sureuploadInvoiceEndCall");
      } else {
        setUploadDescription("sureuploadInvoice");
      }
      setUploadImgSuccess("uploadInvoiceSuccess");
      setShowModal(true);
      const body = {
        invoice: response?.replace(/ /g, "%20"),
      };
      setUploadImgBody(body);
    }
    e.target.value = "";
  };
  const handleLabTestResultUrl = async (e) => {
    const files = e.target.files;
    if (files[0].type !== "application/pdf") {
      toast.error(t("plsUploadPdf"));
      return;
    }
    const response = await handleImageResponse(files[0]);
    if (response) {
      setUploadTitle("labTestResultUrl");
      if(appointment.status === "STARTED"){
        setUploadDescription("sureLabTestResultUrlEndCall");
      }else{
        setUploadDescription("sureLabTestResultUrl");
      }
      setUploadImgSuccess("labTestResultUrlSuccess");
      setShowModal(true);
      const body = {
        labTestResult: response?.replace(/ /g, "%20"),
      };
      setUploadImgBody(body);
    }
    e.target.value = "";
  };

  const medicle = true;
  const renderDetailsView = () => {
    return (
      <div className="chat-section-right">
        {isLoading ? <Widgets.CircularLoader /> : ""}
        <div className={`appointment-details-container p-[1rem] bg-white pb-[3rem] appointment-details-resp ${zoomClass} `}>
          {detail.map((item, i) => (
            <React.Fragment key={i}>
              <InfoComponent
                icon={item.icon}
                title={item.title}
                subtitle={item.subtitle}
                data={item.data}
                extraData={item.extraData}
                status={item.status}
                showAdditionalDataBtn={item.showAdditionalDataBtn}
                showAdditionalDataBtnId={item.showAdditionalDataBtnId}
                fullData={item.fullData ? item.fullData : null}
              />
              {i === detail.length - 1 ? null : <div className="appointment-details-divider" />}
            </React.Fragment>
          ))}

          {["COMPLETED", "STARTED"].includes(appointment.status) && (
            <>
              {appointment?.prescriptionUrl ? (
                <div>
                  <div className="d-flex cursor-pointer" onClick={() => window.open(appointment.prescriptionUrl, "_blank")}>
                    <i className="ri-bar-chart-box-line tab-left-icon-no-hover me-2"></i>
                    <span className="bottom-tabs-titles">{t("viewEPrescription")}</span>
                  </div>
                  <div className="appointment-details-divider" />
                  <button className="replace-button" onClick={() => document.getElementById("fileUpload").click()}>
                    <i className="ri-bar-chart-box-line tab-left-icon-no-hover me-2"></i>
                    <span className="bottom-tabs-titles">{t("replaceEprescription")}</span>
                  </button>
                </div>
              ) : (
                <div className="d-flex cursor-pointer" onClick={() => document.getElementById("fileUpload").click()}>
                  <i className="ri-bar-chart-box-line tab-left-icon-no-hover me-2"></i>
                  <span className="bottom-tabs-titles">{t("uploadEprescription")}</span>
                </div>
              )}
              <input id="fileUpload" type="file" style={{ display: "none" }} onChange={(e) => handleFileUpload(e, "prescription")} />
              <hr />
            </>
          )}

          {["COMPLETED", "STARTED"].includes(appointment.status) && (
            <>
              {appointment.medicalCertificateUrl ? (
                <div>
                  <div className="d-flex cursor-pointer" onClick={() => window.open(appointment.medicalCertificateUrl, "_blank")}>
                    <i className="ri-file-line tab-left-icon-no-hover me-2"></i>
                    <span className="bottom-tabs-titles">{t("viewMedicalCertificate")}</span>
                  </div>
                  <div className="appointment-details-divider" />
                  <button className="replace-button" onClick={() => document.getElementById("certificateUpload").click()}>
                    <i className="ri-file-line tab-left-icon-no-hover me-2"></i>
                    <span className="bottom-tabs-titles">{t("replaceMedicalCertificate")}</span>
                  </button>
                </div>
              ) : (
                <div className="d-flex cursor-pointer" onClick={() => document.getElementById("certificateUpload").click()}>
                  <i className="ri-file-line tab-left-icon-no-hover me-2"></i>
                  <span className="bottom-tabs-titles">{t("uploadMedicalCerti")}</span>
                </div>
              )}
              <input id="certificateUpload" type="file" style={{ display: "none" }} onChange={(e) => handleCertificateUpload(e, "medicalCertificate")} />
              <hr />
            </>
          )}

          {["COMPLETED", "STARTED"].includes(appointment.status) && (
            <>
              {appointment.invoiceUrl ? (
                <div>
                  <div className="d-flex cursor-pointer" onClick={() => window.open(appointment.invoiceUrl, "_blank")}>
                    <i className="ri-file-paper-line tab-left-icon-no-hover me-2"></i>
                    <span className="bottom-tabs-titles">{t("viewInvoice")}</span>
                  </div>
                  <div className="appointment-details-divider" />
                  <button className="replace-button" onClick={() => document.getElementById("invoiceUpload").click()}>
                    <i className="ri-file-paper-line tab-left-icon-no-hover me-2"></i>
                    <span className="bottom-tabs-titles">{t("ReplaceInvoice")}</span>
                  </button>
                </div>
              ) : (
                <div className="d-flex cursor-pointer" onClick={() => document.getElementById("invoiceUpload").click()}>
                  <i className="ri-file-paper-line tab-left-icon-no-hover me-2"></i>
                  <span className="bottom-tabs-titles">{t("UploadInvoice")}</span>
                </div>
              )}
              <input
                id="invoiceUpload"
                type="file"
                style={{ display: "none" }}
                onChange={(e) => handleInvoiceUpload(e, 'invoice')}
              />
              <hr />
            </>
          )}
          {["COMPLETED", "STARTED"].includes(appointment.status) && (
            <>
              {appointment.labTestResultUrl ? (
                <div>
                  <div
                    className="d-flex cursor-pointer"
                    onClick={() => window.open(appointment.labTestResultUrl, "_blank")}
                  >
                    <i className="ri-file-paper-line tab-left-icon-no-hover me-2"></i>
                    <span className="bottom-tabs-titles">{t("viewlabTestResult")}</span>
                  </div>
                  <div className="appointment-details-divider" />
                  <button
                    className="replace-button"
                    onClick={() => document.getElementById("labTestResultUrl").click()}
                  >
                    <i className="ri-file-paper-line tab-left-icon-no-hover me-2"></i>
                    <span className="bottom-tabs-titles">{t("replacelabTestResult")}</span>
                  </button>
                </div>
              ) : (
                <div
                  className="d-flex cursor-pointer"
                  onClick={() => document.getElementById("labTestResultUrl").click()}
                >
                  <i className="ri-file-paper-line tab-left-icon-no-hover me-2"></i>
                  <span className="bottom-tabs-titles">{t("labTestResultUrl")}</span>
                </div>
              )}
              <input
                id="labTestResultUrl"
                type="file"
                style={{ display: "none" }}
                onChange={(e) => handleLabTestResultUrl(e, 'labTestResultUrl')}
              />
            </>
          )}
        </div>

        {showModal && (
          <Widgets.AppDialog
            view={<p className="justify-center-upload">{t(uploadDescription)}</p>}
            setVisibility={setShowModal}
            dialogTitle={t(uploadTitle)}
            dialogPositiveBtnText={t("Yes")}
            dialogNegativeBtnText={t("No")}
            dialogPositiveBtnCall={() => handleImageUpload(uploadImgBody)}
            dialogNegativeBtnCall={() => setShowModal(false)}
            widthType={"small"}
          />
        )}
      </div>
    );
  };

  const detail = [
    {
      icon: <i className="ri-nurse-line me-2"></i>,
      title: t("doctorDetails"),
      subtitle: appointment.doctor.name,
      data: {
        yearGender: appointment.doctor.gender,
        qualification: appointment.doctor.qualification,
      },
    },
    
    {
      icon: <i className="ri-hotel-bed-line me-2" />,
      title: t("PatientDetails"),
      subtitle: appointment?.patient?.fullName,
      data: {
        yearGender: moment(appointment.patient.dateOfBirth).format("DD/MM/YYYY") + ", " + t(appointment.patient.gender),
        phNo: "+" + appointment.patient.countryCode + " " + appointment.patient.phoneNumber,
        email: appointment.patient.email,
        hnNumber: `${t("hnNum")}: ` + appointment.hnNumber,
        // bmiValue : (<PatientInfo
        //   label={t("Patient BMI")}
        // />)
      },
    },
...(appointment.reportURL && appointment.reportURL.length > 0
      ? [
          {
            icon: <i className="ri-file-list-2-line me-2" />,
            title: t("reportUrl"),
            data: {
              symptoms: appointment.reportURL.map((item, i) => (
                <span key={i}
                  className="d-inline-flex align-items-center cursor-pointer"
                  onClick={() => window.open(item, "_blank")}
                >
                  <span className="bottom-tabs-titles">{t("viewReport")}</span>
                </span>
              )),
            },
          },
        ]
      : []),


    ...(appointment.symptoms && appointment.symptoms.length > 0
      ? [
          {
            icon: <i className="ri-file-list-2-line me-2" />,
            title: t("symptoms"),
            data: {
              symptoms: appointment.symptoms.map((item, i) => (
                <span key={i} className="symptoms mt-1 mr-[5px]">
                  {item}
                  {appointment.symptoms.length > i + 1 && ","}
                </span>
              )),
            },
          },
        ]
      : []),
    {
  icon: <i className="ri-time-line me-2" />,
  title: t("AppointmentTime"),
  data: {
    yearGender: t("Start") + " " + moment(appointment.startTime).format("hh:mm A"),
    yearGender1: t("End") + " " + moment(appointment.endTime).format("hh:mm A"),
  },
  showAdditionalDataBtn: appointment.appointmenttimingbtn,
  showAdditionalDataBtnId: utils.constants.appointmentDetailDialog.proposedTimeLog,
},
   {
  icon: <i className="ri-time-line me-2" />,
  title: t("actualRequestedTime"),
  data: {
    yearGender: appointment.requestedTime
      ? moment.tz(appointment.requestedTime, "DD/MM/YYYY HH:mm", "Asia/Ho_Chi_Minh")
          .tz(moment.tz.guess()) // Convert to user's timezone
          .format("HH:mm")
      : "N/A",
  },
},
    // {
    //   icon: <i className='ri-time-line me-2' />,
    //   title: t("Last Appointment"),
    //   data: {
    //   },
    //   showAdditionalDataBtn: true,
    //   showAdditionalDataBtnId:
    //     utils.constants.appointmentDetailDialog.lastAppointment,
    // },
    // {
    //   icon: <i className='ri-checkbox-circle-line me-2' />,
    //   title: t("Appointment Status"),
    //   status: {
    //     icon: <i className='ri-check-double-fill me-2' />,
    //   },
    //   fullData:{
    //   },
    // },
    {
      icon: <i className="ri-bank-card-line me-2" />,
      title: t("paymentStatus"),
      data: {
        paymentstatus: appointment.payment.status === "Pending" ? t("Unpaid") : t(appointment.payment.status),
        paymentstatus1: appointment.payment.currencySymbol + " " + appointment.payment.consultationFee,
        ...(appointment.payment.status === "WaivedOff" && 
            appointment.payment.waiveOffApprovalDate && 
            appointment.payment.waiveOffApproverEmail && 
            appointment.payment.waiveOffReason && 
            appointment.payment.waiveOffApproverName && {
          waiveOffReason: `${t("waiveOffReason")}: ${appointment.payment.waiveOffReason}`,
          waiveOffBy: `${t("waiveOffBy")}: ${appointment.payment.waiveOffApproverName} (${appointment.payment.waiveOffApproverEmail})`,
          waiveOffDate: `${t("waiveOffDate")}: ${moment(appointment.payment.waiveOffApprovalDate).format("DD/MM/YYYY HH:mm")}`,
        }),
      },
    },
    // {
    //   icon: <i className='ri-secure-payment-line me-2' />,
    //   title: t("Payment Mode"),
    //   data: {
    //   },
    // },
    {
      icon: <i className="ri-information-line me-2" />,
      title: t("AppointmentStatus"),
      data: {
        appointmentStatus: (() => {
          switch (appointment.status) {
            case "Pending":
              return t("pending");
            case "CONFIRMED":
              return t("confirmed");
            case "SCHEDULED":
              return t("scheduled");
            case "STARTED":
              return t("STARTED");
            case "COMPLETED":
              return t("COMPLETED");
            case "WAITING_FOR_CLINIC_CONFIRMATION":
              return t("pending");
            default:
              return t(appointment.status);
          }
        })(),
      },
    },

    appointment.payment.status === "COMPLETED" && {
      icon: <i className="ri-secure-payment-line me-2" />,
      title: t("Payment Mode"),
      data: {
        data: appointment.paymentMode,
      },
    },
  ];

  if (!showTab) return null;

  switch (viewState) {
    case "Apointmentdetail":
      return (
        <div className="appointment-section-right">
          <div className="appointment-details d-flex justify-content-between">
            <div></div>
            <div className="text-center">{t("appointmentDetails")}</div>
            <div>
              <i className="ri-close-line appointment-details-close" onClick={() => setShowTab(false)} />
            </div>
          </div>
          {renderDetailsView()}
          <div id="open_ender_output" style={{ display: "none" }}></div>
        </div>
      );

    case "Medicle Notes":
      return (
        <div className="appointment-section-right">
          <div className="appointment-details d-flex justify-content-between">
            <div></div>
            <div className="text-center">{"E-Prescription"}</div>
            <div>
              <i
                className="ri-close-line"
                onClick={() => setviewState("Apointmentdetail")} // Returns to main view
              />
            </div>
          </div>
          <div style={{ minHeight: "600px", padding: "20px" }}>
            <MedicalNotes /> {/* Medical notes component */}
          </div>
          <div id="open_ender_output" style={{ display: "none" }}></div>
        </div>
      );

    case "GeneratePrescription":
      return (
        <div className="appointment-section-right">
          <div className="appointment-details d-flex justify-content-between">
            <div></div>
            <div className="text-center">{"Generate Prescription"}</div>
            <div>
              <i
                className="ri-close-line"
                onClick={() => setviewState("Apointmentdetail")} // Returns to main view
              />
            </div>
          </div>
          <GenerateCertificate /> {/* Prescription generation component */}
          <div id="open_ender_output" style={{ display: "none" }}></div>
        </div>
      );

    default:
      return null;
  }
};

export default ApproveAppointmentDetail;